import { render } from "./templateModal.vue?vue&type=template&id=f86285e4&scoped=true"
import script from "./templateModal.vue?vue&type=script&lang=js"
export * from "./templateModal.vue?vue&type=script&lang=js"

import "./templateModal.vue?vue&type=style&index=0&id=f86285e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f86285e4"]])

export default __exports__